import CircularProgress from '@mui/material/CircularProgress'

import * as S from './styles'

interface ILoadingProps {
  isLoading?: boolean
  fullScreen?: boolean
}

const Loading = ({ isLoading, fullScreen = true }: ILoadingProps) => {
  return isLoading ? (
    <S.ContainerLoad data-testid="load-bg" fullScreen={fullScreen}>
      <CircularProgress data-testid="loading" />
    </S.ContainerLoad>
  ) : (
    <></>
  )
}

export { Loading }
export type { ILoadingProps }
